import * as React from "react";

export default function Title({ children }) {
    return <h1 className="text-5xl font-bold mb-12">{children}</h1>;
}
